"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RAC_ENDPOINT = '/randomized_assignment/v3/config';
class ExperimentConfigurationRequestor {
    constructor(configurationStore, httpClient) {
        this.configurationStore = configurationStore;
        this.httpClient = httpClient;
    }
    async fetchAndStoreConfigurations() {
        const responseData = await this.httpClient.get(RAC_ENDPOINT);
        if (!responseData) {
            return {};
        }
        this.configurationStore.setEntries(responseData.flags);
        return responseData.flags;
    }
}
exports.default = ExperimentConfigurationRequestor;
//# sourceMappingURL=experiment-configuration-requestor.js.map